<div class="home-footer d-flex justify-content-between px-5 py-3">
  <div ngbDropdown class="d-inline-block">
    <button
      type="button"
      class="btn btn-dark footer-menu-btn"
      id="menu"
      ngbDropdownToggle
      [disabled]="isNotInProgress$ | async"
    >
      <i class="fa-solid fa-bars fa-md"></i>
    </button>
    <div ngbDropdownMenu aria-labelledby="menu">
      <div ngbDropdownItem class="form-check form-switch form-switch-right">
        <input
          class="form-check-input footer-switch"
          type="checkbox"
          id="displayAuthorSwitch"
          checked
          (change)="toggleAuthor($event)"
        />
        <label class="form-check-label" for="displayAuthorSwitch">
          {{ "Home.DisplayAuthors" | translate }}</label
        >
      </div>
      <div class="dropdown-divider"></div>
      <button ngbDropdownItem class="text-nowrap" (click)="viewLogs()">
        <u> {{ "Home.ViewLogs" | translate }} ({{ logCount$ | async }})</u>
        <i class="fa-solid fa-info-circle fa-xl ps-2 m-auto"></i>
      </button>
      <div class="dropdown-divider"></div>
      <button ngbDropdownItem class="text-nowrap" (click)="logout()">
        <u>{{ "Home.Logout" | translate }}</u>
        <i class="fa-solid fa-sign-out fa-xl ps-2 m-auto"></i>
      </button>
    </div>
  </div>
  @if (reqFieldCounter$ | async; as counter) {
    <div class="progress-width">
      <progress
        class="progress-bar"
        [ngClass]="{ completed: counter.answered === counter.required }"
        value="{{ counter.answered }}"
        min="0"
        max="{{ counter.required }}"
      ></progress>
      <div class="progress-label">
        <span class="progress-values"
          >{{ counter.answered }}/{{ counter.required }}</span
        >
        {{ "Home.FieldsCompleted" | translate }}
      </div>
    </div>
  }
  <div>
    <button
      class="btn btn-dark"
      (click)="signAndSubmit()"
      [disabled]="disableSubmitButton$ | async"
    >
      {{ "Home.SignAndSubmit" | translate }}
      @if (showButtonSpinner$ | async) {
        <div class="spinner-border small text-light"></div>
      }
    </button>
  </div>
</div>
